import { createActionGroup, props } from '@ngrx/store';

import {
  DashboardScopeFilters,
  DashboardOverviewAccess,
  DashboardWidgetRequests,
  DashboardOverviewResponse,
  DashboardPartnerCounts,
  DashboardPartnerTrackingRequest,
  DashboardPartnerTrackingSearchRequest,
  DashboardPartnerTrackingResponse,
} from '../models/dashboard-api';
import { DashboardLayoutConfig, DashboardPartnerStatus } from '../models/dashboard-config';

export const DashboardActions = createActionGroup({
  source: 'Dashboard',
  events: {
    'Select Layout': props<{ layout: DashboardLayoutConfig }>(),
    'Load Overview': props<{
      filters: DashboardScopeFilters;
      requests: DashboardWidgetRequests;
      access: DashboardOverviewAccess;
    }>(),
    'Load Overview Success': props<{ overview: DashboardOverviewResponse }>(),
    'Load Overview Failure': props<{ error: string }>(),
    'Refresh Operational Overview': props<{
      filters: DashboardScopeFilters;
      requests: DashboardWidgetRequests;
      access: DashboardOverviewAccess;
    }>(),
    'Refresh Operational Overview Success': props<{
      overview: DashboardOverviewResponse;
    }>(),
    'Refresh Operational Overview Failure': props<{ error: string }>(),
    'Refresh Partners Overview': props<{
      filters: DashboardScopeFilters;
      statuses?: DashboardPartnerStatus[];
    }>(),
    'Refresh Partners Overview Success': props<{
      partners: DashboardPartnerCounts;
    }>(),
    'Refresh Partners Overview Failure': props<{ error: string }>(),
    'Load Partner Tracking': props<{
      payload: DashboardPartnerTrackingRequest | DashboardPartnerTrackingSearchRequest;
    }>(),
    'Load Partner Tracking Success': props<{
      tracking: DashboardPartnerTrackingResponse;
    }>(),
    'Load Partner Tracking Failure': props<{ error: string }>(),
  },
});
